const AadyaLocation = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-6xl overflow-hidden rounded-[24px] shadow-[0_24px_70px_rgba(16,38,26,0.12)]">
                    <div className="aspect-[4/3] w-full sm:aspect-[16/9]">
                        <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5122.249941538136!2d80.02930649999999!3d6.3144797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22b2e9e301fe7%3A0x396836a825e25235!2sHiru%20Aadya!5e1!3m2!1sen!2slk!4v1787460234674!5m2!1sen!2slk"
    className="h-full w-full border-0"
    allowFullScreen
    loading="lazy"
    referrerPolicy="strict-origin-when-cross-origin"
    title="Standort von Hiru Aadya"
  />
                    </div>
                </div>
            </div>
        </section>;
};
export default AadyaLocation;
